export default __webpack_public_path__ + "static/media/insta06.fef3eaef.webp";